var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortBy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0AF12C1B-A677-43F6-96BA-05A70667D022") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Weboldal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FT1380-&-FT1390-Crimp-Machines---Lomar-header",
    transform: "translate(-957.000000, -1417.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(958.000000, 1418.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.69002352,2.84996488 C6.19342182,2.0934107 6.0668958,1.08230376 5.39259529,0.473122192 C4.71829455,-0.1360594 3.69957369,-0.159599369 2.9978546,0.417785988 C2.2961355,0.995171283 2.1230416,1.99935493 2.59095709,2.77835351 C3.05887262,3.55735188 4.02668415,3.87623627 4.86602371,3.52796469 C5.20144537,3.38800905 5.48808982,3.1521534 5.69002352,2.84996488 Z",
    id: "Vector-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69002352,13.1649669 C6.19342182,12.4084127 6.0668958,11.3973058 5.39259529,10.7881242 C4.71829455,10.1789426 3.69957369,10.1554026 2.9978546,10.732788 C2.2961355,11.3101733 2.1230416,12.3143569 2.59095709,13.0933555 C3.05887262,13.8723539 4.02668415,14.1912383 4.86602371,13.8429667 C5.20144537,13.7030111 5.48808982,13.4671554 5.69002352,13.1649669 L5.69002352,13.1649669 Z",
    id: "Vector-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30997937,8.00694728 C7.8065813,7.2503931 7.93310711,6.23928616 8.60740775,5.63010459 C9.28170845,5.020923 10.3004293,4.99738303 11.0021483,5.57476839 C11.7038677,6.15215368 11.8769617,7.15633733 11.4090458,7.93533591 C10.9411305,8.71433428 9.97331896,9.03321867 9.1339794,8.68494709 C8.79855781,8.54499145 8.51191318,8.3091358 8.30997937,8.00694728 L8.30997937,8.00694728 Z",
    id: "Vector-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,1.8259888 L14,1.8259888 M2.327,1.8259888 L0,1.8259888 M6,12.1419888 L14,12.1419888 M2.327,12.1419888 L0,12.1419888 M8,6.9839888 L0,6.9839888 M11.673,6.9839888 L14,6.9839888",
    id: "Vector-23"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBy);
export default __webpack_public_path__ + "static/media/Sort_by.acba51f9997744a3940b5780fe1b68f0.svg";
export { ForwardRef as ReactComponent };